// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"d233c030","205":"8ce97e5b","213":"03508fcd","263":"08814aab","315":"daf8d339","364":"812f4ab5","455":"8d437987","558":"2098b79d","632":"39638fed","880":"ec6883a4","885":"bc673871","991":"33a5533f"}[chunkId] + ".chunk.js";
};